// extracted by mini-css-extract-plugin
export default {"wrapper":"Roadmap_wrapper__WEJJY","title":"Roadmap_title__DJhlx","messages":"Roadmap_messages__UWHL2","message":"Roadmap_message__N3V71"};